module.exports = __webpack_public_path__ + "img/levelup_circle.3d8069c7.svg";